(function () {
    "use strict";

    angular.module("app")
        .controller("ProjectCreateController",
            [
                "$scope", "$stateParams", "$filter", "$q", "$timeout", "QUtil", "toaster", "cfpLoadingBar",
                "HierarchyService", "PermissionService",
                "BriefService", "PatternService", "PrototypeService", "SeasonService", "UserService", "LinePlanService",
                "WorkflowService", "SharedData", "SearchHelpService", projectCreateController
            ]);

    angular.module("app")
        .directive("validateStockNumber",
            [
                "$q",
                "PrototypeService",
                validateStockNumber
            ]);

    function validateStockNumber($q, prototypeService) {
        return {
            require: 'ngModel',
            link: function (scope, elem, attr, ctrl) {

                ctrl.$asyncValidators.exists = function (modelValue, viewValue) {
                    return $q(function (resolve, reject) {
                        if (!viewValue) {
                            resolve();
                            return;
                        }

                        prototypeService.isStockNumberValid(viewValue.trim()).then(function (result) {
                            var isValid = result.isValid;

                            if (isValid && attr.validateStockNumber === "projectCreate") {
                                var briefs = scope.$parent.$parent.$parent.briefs;

                                angular.forEach(briefs, function (brief) {
                                    angular.forEach(brief.PatternSeasonals, function (pattern) {
                                        angular.forEach(pattern.PrototypeSeasonals, function (prototype) {
                                            if (prototype !== scope.prototype) {
                                                if (prototype.StockNum === viewValue.trim()) {
                                                    isValid = false;
                                                }
                                            }
                                        });
                                    });
                                });
                            }

                            if (isValid)
                                resolve();
                            else
                                reject();
                        }, function () {
                            reject();
                        });
                    });
                };
            }
        };
    }

    function projectCreateController($scope, $stateParams, $filter, $q, $timeout, qUtil, toaster, cfpLoadingBar, hierarchyService, permissionService,
        briefService, patternService, prototypeService, seasonService, userService, linePlanService, workflowService, sharedData, searchHelpService) {
        var model = this;

        $scope.linePlanId = parseInt($stateParams.linePlanId);
        $scope.briefSeasonalId = parseInt($stateParams.briefSeasonalId);
        $scope.patternSeasonalId = parseInt($stateParams.patternSeasonalId);

        $scope.permissionDenied = function () {
            $state.go('permissionDenied');
        }

        $scope.goToUserPage = function (data) {
            $state.go(data.pageName, data.params);
        }

        $scope.loaderClosed = function () {
            cfpLoadingBar.complete();
        }

        $scope.loaderStart = function () {
            cfpLoadingBar.start();
        }

        //UI Functions
        $scope.addBrief = function () {
            $scope.briefs.push(model.applyBriefDefaults({ BriefSeasonalId: null, scope: {}, PatternSeasonals: [] }));
            model.setHeaderDisabled();
            $scope.clearValidation();
        };

        $scope.removeBrief = function (brief) {
            var index = $scope.briefs.indexOf(brief);
            if (index > -1) {
                $scope.briefs.splice(index, 1);
            }
            model.setHeaderDisabled();
            $scope.clearValidation();
        };

        $scope.copyBrief = function (brief) {
            var copy = angular.copy(brief);
            copy.BriefId = null;
            copy.BriefSeasonalId = null;
            copy.PatternSeasonals = [];
            copy.scope = {};
            $scope.briefs.push(copy);
            $scope.clearValidation();
            $scope.validateBriefName(copy);
        };

        $scope.addPattern = function (brief) {
            brief.PatternSeasonals.push(model.applyPatternDefaults({ PatternSeasonalId: null, PrototypeSeasonals: [], scope: {} }));
            brief.collapsed = false;
            $scope.clearValidation();
        };

        $scope.removePattern = function (brief, pattern) {
            var index = brief.PatternSeasonals.indexOf(pattern);
            if (index > -1) {
                brief.PatternSeasonals.splice(index, 1);
            }
            $scope.clearValidation();
        };

        $scope.copyPattern = function (brief, pattern) {
            var copy = angular.copy(pattern);
            copy.PatternId = null;
            copy.PatternSeasonalId = null;
            copy.PrototypeSeasonals = [];
            copy.scope = {};

            if (!_.some($scope.patternDevTypes, function (d) { return d.DevTypeId === pattern.DevTypeId; })) {
                copy.DevTypeId = null;
                copy.DevTypeDescription = null;
            }

            brief.PatternSeasonals.push(copy);
            $scope.clearValidation();
            $scope.validatePatternName(copy);
        };

        $scope.addPrototype = function (pattern) {
            var proto = model.applyPrototypeDefaults({ PrototypeId: null, GroupList: [], scope: {} });

            pattern.PrototypeSeasonals.push(proto);
            pattern.collapsed = false;

            prototypeService.getProductTypeList(pattern.DevTypeId).then(function (data) {
                proto.GroupList = data;

                if (data.length === 1) {
                    proto.ProductTypeId = data[0].ProductTypeId;
                }
            });
            $scope.clearValidation();
        };

        $scope.copyPrototype = function (pattern, prototype) {
            var copy = angular.copy(prototype);
            copy.PrototypeId = null;
            copy.PrototypeSeasonalId = null;
            copy.scope = {};
            pattern.PrototypeSeasonals.push(copy);
            $scope.clearValidation();
            $scope.validatePrototypeName(copy);
        };

        $scope.removePrototype = function (pattern, prototype) {
            var index = pattern.PrototypeSeasonals.indexOf(prototype);
            if (index > -1) {
                pattern.PrototypeSeasonals.splice(index, 1);
            }
            $scope.clearValidation();
        };

        $scope.closeDefaultsModal = function () {
            $("#defaultsModal").modal("hide");
        };

        $scope.showDefaultsModal = function () {
            model.loadSizeRangePresets();
            $("#defaultsModal").modal("show");
        };

        //Save Functions
        $scope.save = function (isFormInvalid) {
            if (isFormInvalid) {
                model.error("Please review all fields indicated in red.");
                return;
            }

            toaster.clear();
            $scope.clearValidation();

            if ($scope.briefs.length > 0) {
                $scope.saving = true;
                model.saveBriefsRecursive(0).then(function () {
                    $scope.clearValidation();
                }).finally(function () {
                    $scope.saving = false;
                });
            }
        };

        model.saveBriefsRecursive = function (index, deferred) {
            if (!deferred)
                deferred = $q.defer();

            if ($scope.briefs.length > index) {
                var brief = $scope.briefs[index];

                model.saveBrief(brief).then(function () {                       //save this brief
                    model.savePatternsRecursive(brief, 0).then(function () {    //save these patterns
                        model.saveBriefsRecursive(index + 1, deferred);         //save next brief
                    });
                });

            } else {
                deferred.resolve();
            }

            return deferred.promise;
        };

        model.saveBrief = function (brief) {
            if (brief.scope.disabled || brief.scope.saving || !$scope.canCreateBriefs) {
                return $q.resolve();
            }

            var createReq = {
                LinePlanId: $scope.linePlanId,
                ParentBriefSeasonalId: null,
                BriefName: brief.Name,
                BrandId: $scope.brandId,
                SeasonId: $scope.seasonId,
                ResponsibleId: brief.Responsible.Id,
                WFGroupId: brief.WfGroupId
            };

            brief.scope.saving = true;
            brief.scope.disabled = true;

            return briefService.createBriefSeasonal(createReq, true)
                .then(function (response) {
                    brief.BriefSeasonalId = response.briefSeasonalId;
                    brief.BriefId = response.briefId;
                    brief.StatusId = 1;
                    brief.scope.saved = true;
                })
                .catch(function (error) {
                    model.error("There was an error while saving the brief. Please contact system administrator. " + error);
                    brief.scope.disabled = false;
                })
                .finally(function () {
                    brief.scope.saving = false;
                });
        };

        model.savePatternsRecursive = function (brief, index, deferred) {
            if (!deferred) {
                deferred = $q.defer();

                if (brief.PatternSeasonals.length > 0 && brief.StatusId === 1) {
                    briefService.ensureReleased(brief.BriefSeasonalId).then(function (response) {
                        if (response > 1) {
                            brief.StatusId = response;
                            model.savePatternsRecursive(brief, index, deferred);
                        } else {
                            model.error("Brief could not be set to Released, therefore patterns will not be created.");
                        }
                    });

                    return deferred.promise;
                }
            }

            if (brief.PatternSeasonals.length > index) {
                var pattern = brief.PatternSeasonals[index];
                model.savePattern(pattern, brief.BriefId).then(function () {        //save this pattern
                    model.savePrototypesRecursive(pattern, 0).then(function () {     //save these prototypes
                        model.savePatternsRecursive(brief, index + 1, deferred);    //save next pattern
                    });
                });

            } else {
                deferred.resolve(false, index);
            }

            return deferred.promise;
        };

        model.savePattern = function (pattern, briefId) {
            if (pattern.scope.disabled || pattern.scope.saving || !$scope.canCreatePatterns) {
                return $q.resolve();
            }

            var patternData = {
                BriefId: briefId,
                patternName: pattern.Name,
                BrandId: $scope.brandId,
                ProductLine: pattern.ProductLineId,
                GenderKey: pattern.GenderKey,
                Gender: pattern.Gender
            };

            var patternSeasonalData = {
                SeasonId: $scope.seasonId,
                StatusId: 1,
                ResponsibleId: pattern.Responsible.Id,
                WFGroupId: pattern.WfGroupId,
                DevelopmentType: pattern.DevTypeId,
                IsNew: true
            };

            pattern.scope.saving = true;
            pattern.scope.disabled = true;

            return patternService.createPatternSeasonal(patternData, patternSeasonalData, briefId, true)
                .then(function (response) {
                    pattern.PatternSeasonalId = response.Data.PatternSeasonalId;
                    pattern.PatternId = response.Data.PatternId;
                    pattern.StatusId = 1;
                    pattern.scope.saved = true;
                })
                .catch(function (error) {
                    model.error("There was an error while saving the pattern. Please contact system administrator. " + error);
                    pattern.scope.disabled = false;
                })
                .finally(function () {
                    pattern.scope.saving = false;
                });
        };

        model.savePrototypesRecursive = function (pattern, index, deferred) {
            if (!deferred) {
                deferred = $q.defer();

                if (pattern.PrototypeSeasonals.length > 0 && pattern.StatusId === 1) {
                    patternService.ensureReleased(pattern.PatternSeasonalId).then(function (response) {
                        if (response.statusId > 1) {
                            pattern.StatusId = response.statusId;
                            model.savePrototypesRecursive(pattern, index, deferred);
                        } else {
                            model.error("Pattern could not be set to Released, therefore colorways will not be created.");
                        }
                    });

                    return deferred.promise;
                }
            }

            if (pattern.PrototypeSeasonals.length > index) {
                var prototype = pattern.PrototypeSeasonals[index];

                model.savePrototype(prototype, pattern.PatternId).then(function () {    //save this prototype
                    model.savePrototypesRecursive(pattern, index + 1, deferred);        //save next prototype
                });

            } else {
                deferred.resolve(false, index);
            }

            return deferred.promise;
        };

        model.savePrototype = function (prototype, patternId) {
            if (prototype.scope.disabled || prototype.scope.saving || !$scope.canCreatePrototypes) {
                return $q.resolve();
            }

            var proto = {
                PatternId: patternId,
                prototypeName: prototype.Name,
                BrandId: $scope.brandId,
                ProdLine: prototype.ProductLineId,
                DivisionKey: prototype.DivisionKey,
                StockNum: prototype.StockNum ? prototype.StockNum.trim() : null
            };

            var seasonal = {
                SeasonId: $scope.seasonId,
                StatusId: 1,
                ResponsibleId: prototype.Responsible.Id,
                ProductTypeId: prototype.ProductTypeId,
                WFGroupId: prototype.WfGroupId
            };

            prototype.scope.saving = true;
            prototype.scope.disabled = true;

            return prototypeService
                .createPrototypeSeasonal(proto, seasonal, patternId, true, model.defaults.PrototypeSizeRangePresetId)
                .then(function (response) {
                    if (response.IsSuccessful) {
                        prototype.PrototypeSeasonalId = response.Data.PrototypeSeasonalId;
                        prototype.scope.saved = true;
                    } else {
                        model.error(response.Message);
                        prototype.scope.disabled = false;
                    }
                })
                .catch(function (error) {
                    model.error("There was an error while saving the colorway. " + error);
                    prototype.scope.disabled = false;
                })
                .finally(function () {
                    prototype.scope.saving = false;
                });

        };

        //Default Values
        $scope.saveDefaults = function () {

            if (model.defaults.BriefResponsible)
                model.defaults.BriefResponsibleId = model.defaults.BriefResponsible.Id;
            else
                model.defaults.BriefResponsibleId = null;

            if (model.defaults.PatternResponsible)
                model.defaults.PatternResponsibleId = model.defaults.PatternResponsible.Id;
            else
                model.defaults.PatternResponsibleId = null;

            if (model.defaults.PrototypeResponsible)
                model.defaults.PrototypeResponsibleId = model.defaults.PrototypeResponsible.Id;
            else
                model.defaults.PrototypeResponsibleId = null;

            userService.saveProjectCreateDefaults(model.defaults).then(function () {
                model.success("Default values saved successfully!");
            });
        };

        $scope.applyDefaults = function () {
            model.getDefaults().then(function () {
                if (model.defaults) {
                    angular.forEach($scope.briefs, function (brief) {
                        model.applyBriefDefaults(brief);

                        angular.forEach(brief.PatternSeasonals, function (pattern) {
                            model.applyPatternDefaults(pattern);

                            angular.forEach(pattern.PrototypeSeasonals, function (prototype) {
                                model.applyPrototypeDefaults(prototype);
                            });
                        });
                    });
                }
            });
        };

        model.applyBriefDefaults = function (brief) {
            if (!brief.scope.disabled) {
                if (model.defaults.BriefResponsible)
                    brief.Responsible = model.defaults.BriefResponsible;
                if (model.defaults.BriefWfGroupId)
                    brief.WfGroupId = model.defaults.BriefWfGroupId;
            }
            return brief;
        };

        model.applyPatternDefaults = function (pattern) {
            if (!pattern.scope.disabled) {
                if (model.defaults.PatternResponsible)
                    pattern.Responsible = model.defaults.PatternResponsible;
                if (model.defaults.PatternWfGroupId)
                    pattern.WfGroupId = model.defaults.PatternWfGroupId;
                if (model.defaults.PatternDevTypeId) {
                    pattern.DevTypeId = model.defaults.PatternDevTypeId;
                    $scope.patternDevTypeChanged(pattern);
                }
                if (model.defaults.PatternProductLineId)
                    pattern.ProductLineId = model.defaults.PatternProductLineId;
                if (model.defaults.PatternGenderKey) {
                    pattern.GenderKey = model.defaults.PatternGenderKey;

                    searchHelpService.searchGenders({ GenderKey: model.defaults.PatternGenderKey }).then(function (genders) {
                        if (genders.Results.length === 1) {
                            pattern.Gender = genders.Results[0].GenderName;
                        }
                    });
                }
            }
            return pattern;
        };

        model.applyPrototypeDefaults = function (prototype) {
            if (!prototype.scope.disabled) {
                if (model.defaults.PrototypeResponsible)
                    prototype.Responsible = model.defaults.PrototypeResponsible;
                if (model.defaults.PrototypeWfGroupId)
                    prototype.WfGroupId = model.defaults.PrototypeWfGroupId;
                if (model.defaults.PrototypeProductLineId)
                    prototype.ProductLineId = model.defaults.PrototypeProductLineId;
                if (model.defaults.PrototypeDivisionKey)
                    prototype.DivisionKey = model.defaults.PrototypeDivisionKey;
                if (model.defaults.ProductTypeId) {
                    if (_.some(prototype.GroupList, function (g) { return g.ProductTypeId === model.defaults.ProductTypeId; }))
                        prototype.ProductTypeId = model.defaults.ProductTypeId;
                }
            }
            return prototype;
        };

        $scope.setDefaultProductTypeList = function (patternDevTypeId) {
            $scope.defaultProductTypeList = [];

            if (patternDevTypeId) {
                prototypeService.getProductTypeList(patternDevTypeId).then(function (data) {
                    $scope.defaultProductTypeList = data;

                    if (data.length === 1) {
                        model.defaults.ProductTypeId = data[0].ProductTypeId;
                    }
                });
            }
        };

        model.getDefaults = function () {
            return userService.getProjectCreateDefaults($scope.brandId).then(function (defaults) {
                if (defaults) {
                    angular.forEach($scope.users, function (u) {
                        if (u.Id === defaults.BriefResponsibleId)
                            defaults.BriefResponsible = u;
                        if (u.Id === defaults.PatternResponsibleId)
                            defaults.PatternResponsible = u;
                        if (u.Id === defaults.PrototypeResponsibleId)
                            defaults.PrototypeResponsible = u;
                    });

                    model.defaults = defaults;

                    $scope.setDefaultProductTypeList(defaults.PatternDevTypeId);
                } else {
                    model.defaults = {
                        BrandId: $scope.brandId
                    };
                }

                return model.defaults;
            });
        };

        //Validation
        $scope.clearValidation = function () {
            if ($scope.createForm) {
                $scope.createForm.$setPristine();
                $scope.createForm.$setUntouched();
            }
        };

        $scope.validateBriefName = function (brief) {
            brief.briefNameExists = false;

            if (brief.Name) {
                briefService.isBriefNameExists(0, brief.Name, $scope.brandId, $scope.seasonId).then(function (exists) {
                    if (!exists) {
                        angular.forEach($scope.briefs, function (b) {
                            exists = exists || (b !== brief && b.Name === brief.Name);
                        });
                    }

                    brief.briefNameExists = exists;

                    if (exists === true) {
                        model.note("Name Duplication", "You may continue, but please note this name already exists.");
                    }
                });
            }
        };

        $scope.validatePatternName = function (pattern) {
            pattern.patternNameExists = false;

            if (pattern.Name) {
                patternService.isPatternNameExists(0, pattern.Name, $scope.brandId, $scope.seasonId).then(function (exists) {
                    if (!exists) {
                        angular.forEach($scope.briefs, function (brief) {
                            angular.forEach(brief.PatternSeasonals, function (p) {
                                exists = exists || (p !== pattern && p.Name === pattern.Name);
                            });
                        });
                    }

                    pattern.patternNameExists = exists;
                    if (exists === true) {
                        model.note("Name Duplication", "You may continue, but please note this name already exists.");
                    }
                });
            }
        };

        $scope.validatePrototypeName = function (prototype) {
            prototype.prototypeNameExists = false;

            if (prototype.Name) {
                prototypeService.isPrototypeNameExists(0, prototype.Name, $scope.brandId, $scope.seasonId).then(function (exists) {
                    if (!exists) {
                        angular.forEach($scope.briefs, function (brief) {
                            angular.forEach(brief.PatternSeasonals, function (pattern) {
                                angular.forEach(pattern.PrototypeSeasonals, function (p) {
                                    exists = exists || (p !== prototype && p.Name === prototype.Name);
                                });
                            });
                        });
                    }

                    prototype.prototypeNameExists = exists;
                    if (exists === true) {
                        model.note("Name Duplication", "You may continue, but please note this name already exists.");
                    }
                });
            }
        };

        $scope.validateAccountable = function (obj, prop) {
            if (!obj) return;

            prop = prop || "Responsible";

            //If its not an object or doesn't have the correct property theres nothing we can do.
            if (typeof obj !== "object" || !obj.hasOwnProperty(prop)) {
                return;
            }

            //If it doesn't look like a user (has an Id property with a value > 0) we will set the prop to null;
            //Otherwise it will pass.
            if (!obj[prop].hasOwnProperty("Id") || obj[prop].Id <= 0) {
                obj[prop] = null;
            }
        };

        //Load data
        $scope.loadBrandData = function () {
            var deferred = $q.defer();

            cfpLoadingBar.start();

            if ($scope.brandId) {
                qUtil.whenAll([
                    function () { return model.getUsersByBrand($scope.brandId); },
                    function () { return $scope.getSeasonsByBrand($scope.brandId); },
                    function () { return model.getWFGroups($scope.brandId); }
                ]).then(function () {
                    model.getDefaults($scope.brandId).then(function () {
                        $scope.clearValidation();
                        deferred.resolve();
                        cfpLoadingBar.complete();
                    });
                });

                $scope.brandName = "";
                $scope.sapBrandId = null;

                angular.forEach($scope.brands, function (b) {
                    if (b.BrandId === $scope.brandId) {
                        $scope.brandName = b.BrandName;
                        $scope.sapBrandId = b.SAPBrandId;
                    }
                });
            } else {
                $scope.seasons = [];
                $scope.linePlans = [];
                $scope.briefGroups = [];
                $scope.patternGroups = [];
                $scope.prototypeGroups = [];
                model.defaults = null;
                deferred.resolve();
            }

            return deferred.promise;
        };

        $scope.loadLinePlans = function () {
            if ($scope.brandId && $scope.seasonId) {
                linePlanService.getLinePlansByBrandSeason($scope.brandId, $scope.seasonId).then(function (linePlans) {
                    $scope.linePlans = $filter("filter")(linePlans, function (lp) {
                        return lp.StatusId === 2 || lp.StatusId === 3;
                    });

                    var selectedLinePlan = $filter("filter")($scope.linePlans, function (lp) {
                        return lp.LinePlanId === $scope.linePlanId;
                    });

                    if (selectedLinePlan.length === 1) {
                        return;
                    } else if ($scope.linePlans.length === 1) {
                        $scope.linePlanId = $scope.linePlans[0].LinePlanId;
                    }
                });
            } else {
                $scope.linePlans = [];
            }
        };

        $scope.getSeasonsByBrand = function (brandId) {
            return seasonService.getSeasonsByBrand(brandId).then(function (data) {
                $scope.seasons = data;
                $scope.loadLinePlans();
            });
        };

        model.productTypeListCache = {};
        $scope.patternDevTypeChanged = function (pattern) {

            var setList = function (data) {
                model.productTypeListCache[pattern.DevTypeId] = data;

                _.each(pattern.PrototypeSeasonals, function (proto) {
                    proto.GroupList = data;

                    if (data.length === 1) {
                        proto.ProductTypeId = data[0].ProductTypeId;
                    }
                });
            };

            if (model.productTypeListCache[pattern.DevTypeId]) {
                setList(model.productTypeListCache[pattern.DevTypeId]);
                return;
            }

            prototypeService.getProductTypeList(pattern.DevTypeId).then(function (data) {
                setList(data);
            });
        };

        model.getUsersByBrand = function (brandId) {
            return userService.getUsersByBrand(brandId).then(function (data) {
                $scope.users = data;
            });
        };

        model.getWFGroups = function (brandId) {
            var deferred = $q.defer();

            qUtil.whenAll([
                function () { return workflowService.getWFGroups(brandId, 2).then(function (data) { $scope.briefGroups = data; }); },
                function () { return workflowService.getWFGroups(brandId, 3).then(function (data) { $scope.patternGroups = data; }); },
                function () { return workflowService.getWFGroups(brandId, 4).then(function (data) { $scope.prototypeGroups = data; }); }
            ]).then(deferred.resolve);

            return deferred.promise;
        };

        model.getDevTypes = function () {
            return patternService.getDevelopmentTypeList(true).then(function (devTypes) {
                $scope.patternDevTypes = devTypes;
            });
        };

        model.getProductLineList = function () {
            return patternService.getProductLineList().then(function (prodLines) {
                $scope.productlines = prodLines;
            });
        };

        model.loadHierarchy = function (briefSeasonalId, patternSeasonalId) {
            cfpLoadingBar.start();

            return hierarchyService.getHierarchyTreeModel(null, briefSeasonalId, patternSeasonalId, null).then(function (h) {
                if (h.LinePlans.length > 0) {
                    $scope.brandId = h.LinePlans[0].BrandId;
                    $scope.seasonId = h.LinePlans[0].SeasonId;
                    $scope.linePlanId = h.LinePlans[0].LinePlanId;

                    $scope.loadBrandData().then(function () {
                        if (h.LinePlans[0].BriefSeasonals.length > 0) {
                            var brief = h.LinePlans[0].BriefSeasonals[0];

                            brief.PatternSeasonals = $filter("filter")(brief.PatternSeasonals, function (ps) {
                                model.mapFromHierarchy(ps);
                                ps.PrototypeSeasonals = [];
                                return ps.PatternSeasonalId === patternSeasonalId;
                            });

                            $scope.briefs.push(model.mapFromHierarchy(brief));

                            if (briefSeasonalId && !patternSeasonalId) {
                                $scope.addPattern($scope.briefs[0]);
                            }

                            if (patternSeasonalId && $scope.briefs[0].PatternSeasonals.length > 0) {
                                $scope.addPrototype($scope.briefs[0].PatternSeasonals[0]);
                            }
                        }
                    });
                }
            });
        };

        model.loadLinePlan = function (linePlanId, addBrief) {
            return linePlanService.getLinePlanHeaderInfo(linePlanId).then(function (linePlan) {
                if (linePlan) {

                    $scope.brandId = linePlan.BrandId;
                    $scope.seasonId = linePlan.SeasonId;
                    $scope.linePlanId = linePlan.LinePlanId;

                    $scope.loadBrandData().then(function () {
                        if (addBrief)
                            $scope.addBrief();
                    });

                    model.setHeaderDisabled();
                }
            });
        };

        model.loadSizeRangePresets = function () {
            return userService.getSizeRangePresets().then(function (data) {
                $scope.sizeRangePresets = data;
            });
        };

        model.mapFromHierarchy = function (obj) {
            if (obj.ResponsibleId === 1) {
                obj.Responsible = { Id: 1, FullName: "System User" };
            } else {

                var users = $filter("filter")($scope.users, function (u) {
                    return u.Id === obj.ResponsibleId;
                });

                if (users.length === 1) {
                    obj.Responsible = users[0];
                }
            }

            obj.scope = { disabled: true, existing: true };

            return obj;
        };

        model.mapFromBriefSearchResult = function (obj) {
            var brief = {
                Name: obj.BriefName,
                BriefSeasonalId: obj.BriefSeasonalId,
                PatternSeasonals: [],
                ResponsibleName: obj.AccountableName,
                ResponsibleId: obj.AccountableId,
                WfGroupId: obj.WFGroupId,
                BriefId: obj.BriefId,
                StatusId: obj.StatusId
            };

            return model.mapFromHierarchy(brief);
        };

        model.mapFromPatternSearchResult = function (obj) {
            var pattern = {
                Name: obj.PatternName,
                PatternSeasonalId: obj.PatternSeasonalId,
                PrototypeSeasonals: [],
                ResponsibleName: obj.Accountable,
                ResponsibleId: obj.AccountableId,
                WfGroupId: obj.WFGroupId,
                PatternId: obj.PatternId,
                DevTypeId: obj.DevelopmentTypeId,
                DevTypeDescription: obj.DevelopmentType,
                StatusId: obj.StatusId,
                Gender: obj.Gender,
                GenderKey: obj.GenderKey
            };

            return model.mapFromHierarchy(pattern);
        };

        model.setHeaderDisabled = function () {
            var briefSeasonalId = parseInt($stateParams.briefSeasonalId);
            var patternSeasonalId = parseInt($stateParams.patternSeasonalId);

            $scope.headerDisabled = !isNaN(briefSeasonalId) || !isNaN(patternSeasonalId) || $scope.briefs.length > 0;
        };

        model.setPermissions = function () {
            $scope.canReadBriefs = permissionService.canReadBrief();
            $scope.canReadPatterns = permissionService.canReadPattern();

            $scope.canCreateBriefs = permissionService.canCreateBrief();
            $scope.canCreatePatterns = permissionService.canCreatePattern();
            $scope.canCreatePrototypes = permissionService.canCreatePrototype();
        };

        $scope.searchModal = {
            searching: false,
            searchResults: [],
            searchType: "",
            brief: null,
            filterText: null,

            search: function (pageNumber, pageSize) {
                if ($scope.searchModal.searchType === "Brief")
                    $scope.searchModal.searchBriefs(pageNumber, pageSize);
                else if ($scope.searchModal.searchType === "Pattern")
                    $scope.searchModal.searchPatterns($scope.searchModal.brief, pageNumber, pageSize);
            },

            searchBriefs: function (pageNumber, pageSize) {
                $scope.searchModal.searchType = "Brief";
                $scope.searchModal.searching = true;

                var searchParams = {
                    LinePlanId: $scope.linePlanId,
                    SeasonId: $scope.seasonId,
                    BrandId: $scope.brandId,
                    StatusId: 2,
                    StatusIdSecondary: 3,
                    BriefName: $scope.searchModal.filterText
                };

                briefService.searchBriefs(searchParams, pageNumber || 1, pageSize || 50, "", "").then(function (results) {
                    $scope.searchModal.searchResults = results.results;

                    $scope.searchModal.pagerData = {
                        CurrentPageNumber: results.currentPage,
                        PageSize: results.pageSize,
                        TotalRecords: results.totalRecords,
                        TotalPageCount: results.totalPages
                    };

                    $scope.searchModal.searching = false;
                });
            },

            searchPatterns: function (brief, pageNumber, pageSize) {
                $scope.searchModal.searchType = "Pattern";
                $scope.searchModal.brief = brief;
                $scope.searchModal.searching = true;

                var searchParams = {
                    BriefSeasonalId: brief.BriefSeasonalId,
                    StatusId: 2,
                    StatusIdSecondary: 3,
                    PatternName: $scope.searchModal.filterText
                };

                patternService.searchPatterns(searchParams, pageNumber || 1, pageSize || 50, "", "").then(function (results) {
                    $scope.searchModal.searchResults = results.results;

                    $scope.searchModal.pagerData = {
                        CurrentPageNumber: results.currentPage,
                        PageSize: results.pageSize,
                        TotalRecords: results.totalRecords,
                        TotalPageCount: results.totalPages
                    };

                    $scope.searchModal.searching = false;
                });
            },

            select: function (item) {
                if ($scope.searchModal.searchType === "Brief")
                    $scope.briefs.push(model.mapFromBriefSearchResult(item));
                else if ($scope.searchModal.searchType === "Pattern")
                    $scope.searchModal.brief.PatternSeasonals.push(model.mapFromPatternSearchResult(item));

                model.setHeaderDisabled();

                $("#searchModal").modal("hide");
            },

            uiFilter: function (item) {
                if ($scope.searchModal.searchType === "Brief")
                    return !_.some($scope.briefs, function (brief) {
                        return brief.BriefSeasonalId === item.BriefSeasonalId;
                    });
                else if ($scope.searchModal.searchType === "Pattern")
                    return !_.some($scope.searchModal.brief.PatternSeasonals, function (pattern) {
                        return pattern.PatternSeasonalId === item.PatternSeasonalId;
                    });
                return true;
            }
        };

        model.isFormUnsaved = function () {
            return _.some($scope.briefs, function (brief) {
                return !brief.scope.saved || _.some(brief.PatternSeasonals, function (pattern) {
                    return !pattern.scope.saved || _.some(pattern.PrototypeSeasonals, function (prototype) {
                        return !prototype.scope.saved;
                    });
                });
            });
        };

        $scope.init = function () {
            var isUnsaved = model.isFormUnsaved();
            if (isUnsaved === false || confirm("Are you sure you want to start over? All work you have started will be lost.")) {
                model.init();
            }
        };

        model.init = function () {
            $scope.briefs = [];
            $scope.linePlans = [];

            model.setPermissions();

            qUtil.whenAll([
                function () { return model.getDevTypes(); },
                function () { return model.getProductLineList(); },
                function () { return model.loadSizeRangePresets(); }
            ]).then(function () {
                sharedData.getUserDefaults().then(function (userDefaults) {
                    if (userDefaults) {
                        $scope.brands = userDefaults.brands;
                        $scope.seasons = userDefaults.seasons;

                        var linePlanId = parseInt($stateParams.linePlanId);
                        var briefSeasonalId = parseInt($stateParams.briefSeasonalId);
                        var patternSeasonalId = parseInt($stateParams.patternSeasonalId);

                        if (linePlanId > 0) {
                            model.loadLinePlan(linePlanId, true);
                        }
                        else if (briefSeasonalId > 0 || patternSeasonalId > 0) {
                            model.loadHierarchy(briefSeasonalId, patternSeasonalId);
                        } else {
                            $scope.brandId = userDefaults.brandId;
                            $scope.seasonId = userDefaults.seasonId;

                            if (userDefaults.brandId)
                                $scope.loadBrandData();
                            else
                                cfpLoadingBar.complete();
                        }
                    }

                    model.setHeaderDisabled();
                });
            });
        };

        //model.init();

        var searchTimer = null;
        $scope.$watch("searchModal.filterText", function () {
            if (searchTimer) {
                $timeout.cancel(searchTimer);
                searchTimer = null;
            }

            if (!$scope.searchModal.pagerData) return;

            searchTimer = $timeout(function () {
                $scope.searchModal.search(1, $scope.searchModal.pagerData.PageSize);
                searchTimer = null;
            }, 250);
        });

        model.error = function (message) {
            toaster.clear();
            toaster.pop({ type: "error", title: "Error!", body: message, timeout: 5000 });
        };

        model.success = function (message) {
            toaster.clear();
            toaster.pop({ type: "success", title: "Success!", body: message, timeout: 5000 });
        };

        model.note = function (title, message) {
            toaster.clear();
            toaster.pop({ type: "note", title: title, body: message, timeout: 5000 });
        };
    }
})();
